import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';

const importUserSettings = () => import(/* webpackChunkName: "user-settings" */ './containers/UserSettingsContainer');

const UserSettingsRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <SentryBoundary owner={sentryConstants.TEAMS.IAM}>
      <BundleRoute
        load={importUserSettings}
        path={match.url}
      />
    </SentryBoundary>
  </LoginRequiredContainer>
);

UserSettingsRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default UserSettingsRoutes;
